import type { DocumentSection } from "./types";
import {
  createBlankTemplateFooterRow,
  createBlankTemplateHeaderRow,
} from "./templates";

export type SnippetId = "header" | "footer";

export type Snippet = {
  id: SnippetId;
  label: string;
  description: string;
  build: () => DocumentSection[];
};

export const SNIPPET_CATALOG: Snippet[] = [
  {
    id: "header",
    label: "Header",
    description: "Club logo",
    build: () => [createBlankTemplateHeaderRow()],
  },
  {
    id: "footer",
    label: "Footer",
    description: "Address and unsubscribe link",
    build: () => [createBlankTemplateFooterRow()],
  },
];

export function getSnippetById(id: SnippetId): Snippet | undefined {
  return SNIPPET_CATALOG.find(snippet => snippet.id === id);
}
